<template>
  <!-- deviceReport 设备报表 -->
  <div class="virtualDeviceRTValueBody">
    <elRadioTree
      slot="tree"
      :dataList="virtualDeviceList"
      @checkItem="mysearch"
    ></elRadioTree>
    <div class="VirtualDeviceRTValueRigth" slot="body">
      <!--日期弹窗-->
      <datePicker
        ref="datePicker"
        :initDate="nowSelectDate"
        @selectDate="selectDate"
        @selectMonth="selectDate"
        @selectYear="selectDate"
        :type="datePickerType"
      ></datePicker>
      <div class="monreportRigth" slot="body">
        <div class="buttonLine">
          <label>应用类型组：</label>
          <el-select
            v-model="apptypeValue"
            multiple
            collapse-tags
            placeholder="请选择"
            size="small"
          >
            <el-option
              label="全选"
              value="全选"
              @click.native="selectAll"
            ></el-option>
            <el-option
              v-for="item in apptypeGroups"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <timeTypeSelection
            @selectTimetype="nowTimetype = $event"
          ></timeTypeSelection>
          <!--日期-->
          <iconButton
            icoName="wedoButton/date.png"
            :buttonText="nowDateText"
            @buttonClick="$refs.datePicker.show()"
          >
          </iconButton>
          <iconButton
            icoName="wedoButton/search.png"
            buttonText="查询"
            @buttonClick="mysearch"
          ></iconButton>
          <iconButton
            icoName="wedoButton/download.png"
            buttonText="导出"
            @buttonClick="exportExcel"
          ></iconButton>
        </div>
        <!--图表-->
        <vchart
          style="height: calc(65% - 0.37rem);background: white;"
          ref="vchart"
        ></vchart>
        <!--表格显示数据-->

        <el-table
          :data="nowPage"
          :header-cell-style="{ 'text-align': 'center', background: '#F1F4F7' }"
          :cell-style="{ 'text-align': 'center' }"
          max-height="200"
          border
        >
          <template slot="empty">
            <span class="noData">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column fixed type="index" width="50"></el-table-column>
          <el-table-column fixed prop="0" label="名称" width="180">
          </el-table-column>
          <el-table-column
            v-for="(item, index) in columns"
            :prop="(index + 1).toString()"
            :label="item.name"
            :key="item.key"
          >
          </el-table-column>
        </el-table>
        <div class="tabled">
          <el-pagination
            @current-change="nowIndex = $event - 1"
            :page-size="pageLen"
            layout="total, prev, pager, next, jumper"
            :total="nowShowDataList.length"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import treeBody from "@/components/module/slotModule/treeBody.vue";
import datePicker from "@/components/module/universal/datePicker.vue";
import virtualDeviceTree from "@/components/module/tree/virtualDeviceTree.vue";
import iconButton from "@/components/module/universal/iconButton.vue";
import vchart from "@/components/module/chart/vchart.vue";
import timeTypeSelection from "@/components/module/selection/timeTypeSelection.vue";
import elRadioTree from "@/components/module/tree/elRadioTree.vue";
export default {
  components: {
    treeBody,
    datePicker,
    virtualDeviceTree,
    iconButton,
    vchart,
    timeTypeSelection,
    elRadioTree,
  },
  props: [],
  data() {
    return {
      nowPage: this.$store.resourcesStore.state.nowPage,
      apptypeGroups: this.$store.resourcesStore.state.apptypeGroups,
      nowApptypeGroups: [],
      dataObject: {},
      totalSize: 0,
      pageLen: 100,
      nowIndex: 0,
      options: this.$store.resourcesStore.state.options2,
      from2name: {},
      nowTimetype: "day",
      apptypeValue: ["全选"],
    };
  },
  created() {},
  mounted() {
    //初始化图表
    this.$refs.vchart.setData(this.options, true);
  },

  computed: {
    getBackgroudImageStyle() {
      return this.$store.resourcesStore.getters.getBackgroudImageStyle;
    },
    getResourcesByName() {
      return this.$store.resourcesStore.getters.getResourcesByName;
    },
    nowSelectDate() {
      return this.$store.cacheStore.getters.getNowSelectDate;
    },
    virtualDeviceList() {
      var data = this.$store.deviceStore.getters.getReadDeviceTree;
      return isempty(data) ? [] : [deviceList(data)];
    },
    nowDateText() {
      switch (this.nowTimetype) {
        case "day":
        case "week":
          return this.nowSelectDate.formatByDate("-");
          break;
        case "month":
        case "quarter":
          return this.nowSelectDate.formatByMonth("-");
          break;
        case "year":
          return this.nowSelectDate.getFullYear() + "年";
          break;
      }
    },
    datePickerType() {
      switch (this.nowTimetype) {
        case "day":
        case "week":
          return "day";
        case "month":
        case "quarter":
          return "month";
        case "year":
          return "year";
      }
    },
    variableTree() {
      if (this.nowVirtualDevice == undefined) {
        return [];
      }
      return this.$store.variableStore.getters.getVariableTree(
        this.nowVirtualDevice.no
      );
    },
    nowVariableNames() {
      //当前应该显示的变量fromName列表
      var ag = this.nowApptypeGroups.map((item) => {
        return item.id;
      });
      var v1 = this.variableTree.filter((item) => {
        return ag.includes(item.id);
      });
      if (isempty(v1)) {
        return [];
      }
      var v2 = [];
      v1.forEach((item) => {
        item.next.forEach((i) => {
          v2.push(i.fromName); //fromName
        });
      });
      return v2;
    },

    nowShowDataList() {
      //当前应该显示的数据列表
      var list = [];
      switch (this.nowTimetype) {
        case "day":
          //只取出要显示的变量的数据
          for (var i = 0, len = this.nowVariableNames.length; i < len; i++) {
            var item = this.dataObject[this.nowVariableNames[i]];
            if (!isempty(item)) {
              list.push(item);
            }
          }
          break;
        case "week":
          var baseList = [];
          //只取出要显示的变量的数据
          for (var i = 0, len = this.nowVariableNames.length; i < len; i++) {
            var item = this.dataObject[this.nowVariableNames[i]];
            if (!isempty(item)) {
              baseList.push(item);
            }
          }
          //精简多余数据，只留下要显示的数据,这里是一个名称和七个值
          for (var i = 0, len = baseList.length; i < len; i++) {
            var item = baseList[i];
            var vList = [];
            var name = undefined;
            var max = undefined;
            var min = undefined;
            for (var i2 = 0, len2 = item.length; i2 < len2; i2++) {
              var item2 = baseList[i][i2];
              if (!isempty(item2.variablename)) {
                name = this.from2name[item2.variablename]
                  ? this.from2name[item2.variablename]
                  : item2.variablename;
                name = name.subByFirstChar(".");
              }
              //最大值
              if (!this.$historyTools.isNull(item2.max)) {
                if (max == undefined) {
                  max = item2.max;
                } else {
                  if (max < item2.max) {
                    max = item2.max;
                  }
                }
              }
              //最小值
              if (!this.$historyTools.isNull(item2.min)) {
                if (min == undefined) {
                  min = item2.min;
                } else {
                  if (min > item2.min) {
                    min = item2.min;
                  }
                }
              }

              if (!isnull(item2.avg)) {
                vList.push(item2.avg);
                continue;
              }
              //没有平均值，自己算
              var count = 0;
              var sum = 0;
              item2.data.forEach((value) => {
                if (!isnull(value)) {
                  //只计算有效值
                  sum += value;
                  count++;
                }
              });
              if (count == 0) {
                //一个有效值都没有
                vList.push(undefined);
                continue;
              }
              vList.push(cutDigital(sum / count));
            }
            if (name == undefined) {
              continue;
            }
            list.push({
              name: name,
              max: max,
              min: min,
              data: vList,
            });
          }
          break;
        case "month":
          //只取出要显示的变量的数据
          for (var i = 0, len = this.nowVariableNames.length; i < len; i++) {
            var item = this.dataObject[this.nowVariableNames[i]];
            if (!isempty(item)) {
              list.push(item);
            }
          }
          break;
        case "quarter":
          var baseList = [];
          //只取出要显示的变量的数据
          for (var i = 0, len = this.nowVariableNames.length; i < len; i++) {
            var item = this.dataObject[this.nowVariableNames[i]];
            if (!isempty(item)) {
              baseList.push(item);
            }
          }
          //精简多余数据，只留下要显示的数据,这里是一个名称和七个值
          for (var i = 0, len = baseList.length; i < len; i++) {
            var item = baseList[i];
            var vList = [];
            var name = undefined;
            var max = undefined;
            var min = undefined;
            // 3个月
            for (var i2 = 0, len2 = item.length; i2 < len2; i2++) {
              var item2 = item[i2];
              if (!isempty(item2.variablename)) {
                name = this.from2name[item2.variablename]
                  ? this.from2name[item2.variablename]
                  : item2.variablename;

                name = name.subByFirstChar(".");
              }
              //最大值
              if (!this.$historyTools.isNull(item2.max)) {
                if (max == undefined) {
                  max = item2.max;
                } else {
                  if (max < item2.max) {
                    max = item2.max;
                  }
                }
              }
              //最小值
              if (!this.$historyTools.isNull(item2.min)) {
                if (min == undefined) {
                  min = item2.min;
                } else {
                  if (min > item2.min) {
                    min = item2.min;
                  }
                }
              }
              if (!isnull(item2.avg)) {
                vList.push(item2.avg);
                continue;
              }
              //没有平均值，自己算
              var count = 0;
              var sum = 0;
              item2.data.forEach((value) => {
                if (!isnull(value)) {
                  //只计算有效值
                  sum += value;
                  count++;
                }
              });
              if (count == 0) {
                //一个有效值都没有
                vList.push(undefined);
                continue;
              }
              vList.push(cutDigital(sum / count));
            }
            if (name == undefined) {
              continue;
            }
            list.push({
              name: name,
              max: max,
              min: min,
              data: vList,
            });
          }
          break;
        case "year":
          // 只取出要显示的变量的数据,即一个长度为12的数组，再插入变量名
          for (let i = 0, len = this.nowVariableNames.length; i < len; i++) {
            var name = this.from2name[this.nowVariableNames[i]]
              ? this.from2name[this.nowVariableNames[i]]
              : this.nowVariableNames[i];
            var nList = [name.subByFirstChar("."), "max", "min"];
            var vList = this.dataObject[this.nowVariableNames[i]];
            if (isempty(vList)) {
              continue;
            }
            var max = undefined;
            var min = undefined;
            vList.forEach((item) => {
              if (isempty(item.data)) {
                nList.push(undefined);
                return;
              }
              // 计算最大值
              if (!this.$historyTools.isNull(item.max)) {
                if (max == undefined) {
                  max = item.max;
                } else {
                  if (max < item.max) {
                    max = item.max;
                  }
                }
              }
              // 计算最小值
              if (!this.$historyTools.isNull(item.min)) {
                if (min == undefined) {
                  min = item.min;
                } else {
                  if (min > item.min) {
                    min = item.min;
                  }
                }
              }
              if (!isnull(item.avg)) {
                nList.push(item.avg);
                return;
              }
              // 计算有效值平均值
              var sum = 0;
              var count = 0;
              item.data.forEach((value) => {
                if (!isnull(value)) {
                  //只计算有效值
                  sum += value;
                  count++;
                }
              });
              if (count == 0) {
                //一个有效值都没有
                nList.push(undefined);
              } else {
                nList.push(cutDigital(sum / count));
              }
            });
            nList[1] = max;
            nList[2] = min;
            list.push(nList);
          }
          break;
      }
      return list;
    },
    columns() {
      //列表的项，每个整点值
      var list = [];
      switch (this.nowTimetype) {
        case "day":
          list.push({
            name: "最大值",
          });
          list.push({
            name: "最小值",
          });
          for (var i = 0; i < 24; i++) {
            list.push({
              name: (i < 10 ? "0" : "") + i + ":00",
            });
          }
          break;
        case "week":
          list = [
            {
              name: "最大值",
            },
            {
              name: "最小值",
            },
            {
              name: "星期一",
            },
            {
              name: "星期二",
            },
            {
              name: "星期三",
            },
            {
              name: "星期四",
            },
            {
              name: "星期五",
            },
            {
              name: "星期六",
            },
            {
              name: "星期日",
            },
          ];
          break;
        case "month":
          list.push({
            name: "最大值",
          });
          list.push({
            name: "最小值",
          });
          for (var i = 1; i < 32; i++) {
            list.push({
              name: i + "日",
            });
          }
          break;
        case "quarter":
          list = [];
          list.push({
            name: "最大值",
          });
          list.push({
            name: "最小值",
          });
          var quarter = parseInt((this.nowSelectDate.getRealMonth() + 2) / 3);
          var Month = [
            [
              {
                name: "一月",
              },
              {
                name: "二月",
              },
              {
                name: "三月",
              },
            ],
            [
              {
                name: "四月",
              },
              {
                name: "五月",
              },
              {
                name: "六月",
              },
            ],
            [
              {
                name: "七月",
              },
              {
                name: "八月",
              },
              {
                name: "九月",
              },
            ],
            [
              {
                name: "十月",
              },
              {
                name: "十一月",
              },
              {
                name: "十二月",
              },
            ],
          ];
          list = list.concat(Month[quarter - 1]);
          break;
        case "year":
          list.push(
            {
              name: "最大值",
            },
            {
              name: "最小值",
            }
          );
          for (var i = 1; i < 13; i++) {
            list.push({
              name: i + "月",
            });
          }
          break;
      }
      return list;
    },

    allVariableName() {
      //所有的通讯变量名称
      var list = [];
      for (var i = 0, len = this.variableTree.length; i < len; i++) {
        var next = this.variableTree[i].next;
        for (var i2 = 0, len2 = next.length; i2 < len2; i2++) {
          var item = next[i2];
          this.from2name[item.fromName] = item.name;
          list.push(item.fromName); //fromName
        }
      }
      return list;
    },
    nowSelectAppTypeGroupIds() {
      return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(
        this.apptypeGroups
      );
    },
    nowVirtualDevice() {
      return this.$store.deviceStore.state.nowVirtualDevice;
    },
  },
  methods: {
    getMath(index) {
      if (!index) {
        index = 10;
      }
      var min = index - index / 10; // 确保min是整数
      var max = index + index / 10; // 确保max是整数
      var d = Math.floor(Math.random() * (max - min + 1)) + min;
      if (d) {
        return d.toFixed(2);
      }
      return d;
    },
    mysearch() {
      this.options.series.map((v) => {
        v.data.map((a) => {
          a[1] = this.getMath(a[1]);
        });
      });

      this.$refs.vchart.setData(this.options, true);
      this.nowPage.map((v) => {
        v.map((a, i) => {
          if (i) {
            v[i] = this.getMath(v[i]);
          }
        });
      });
    },
    selectAll() {
      //全选 先判断是否有选中的，有选中就清空
      if (this.apptypeValue.length == 1) {
        let idList = [];
        this.apptypeGroups.forEach((item) => {
          idList.push(item.id);
        });
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", idList);
        this.apptypeValue = idList;
      } else {
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", []);
        this.apptypeValue = [];
      }
    },
    autoSelectMethod(item, index) {
      if (this.nowVirtualDevice != undefined) {
        return (
          this.nowVirtualDevice.id == item.id &&
          this.nowVirtualDevice.type == item.type
        );
      } else {
        return item.type == "virtualDevice";
      }
    },
    selectDate(date) {
      this.$store.cacheStore.commit("setNowSelectDate", date);
      this.$refs.datePicker.hide();
    },
    search() {
      //查询数据
    },
    // 数据导出
    exportExcel() {
      switch (this.nowTimetype) {
        case "day":
          var title = this.nowVirtualDevice.name + this.nowDateText + "日报";
          var info = {};
          info[title] = this.nowVariableNames;
          this.$api.reportApi.exportVariableHistoryWithDateType(
            JSON.stringify(info),
            this.nowSelectDate.getTime(),
            undefined,
            60,
            title,
            "day",
            (respon) => {
              saveAs(
                DWSystemSetting.downloadUrl + "/" + respon,
                title + ".xls"
              );
            }
          );
          break;
        case "week":
          var title = this.nowVirtualDevice.name + this.nowDateText + "周报";
          var info = {};
          info[title] = this.nowVariableNames;
          this.$api.reportApi.exportVariableHistoryWithDateType(
            JSON.stringify(info),
            this.nowSelectDate.getTime(),
            undefined,
            60,
            title,
            "week",
            (respon) => {
              saveAs(
                DWSystemSetting.downloadUrl + "/" + respon,
                title + ".xls"
              );
            }
          );
          break;
        case "month":
          var title = this.nowVirtualDevice.name + this.nowDateText + "月报";
          var info = {};
          info[title] = this.nowVariableNames;
          this.$api.reportApi.exportVariableHistoryWithDateType(
            JSON.stringify(info),
            this.nowSelectDate.getTime(),
            undefined,
            60,
            title,
            "month",
            (respon) => {
              saveAs(
                DWSystemSetting.downloadUrl + "/" + respon,
                title + ".xls"
              );
            }
          );
          break;
        case "quarter":
          var title = this.nowVirtualDevice.name + this.nowDateText + "月_季报";
          var info = {};
          info[title] = this.nowVariableNames;
          this.$api.reportApi.exportVariableHistoryWithDateType(
            JSON.stringify(info),
            this.nowSelectDate.getTime(),
            undefined,
            60,
            title,
            "quarter",
            (respon) => {
              saveAs(
                DWSystemSetting.downloadUrl + "/" + respon,
                title + ".xls"
              );
            }
          );
          break;
        case "year":
          var title = this.nowVirtualDevice.name + this.nowDateText + "报";
          var info = {};
          info[title] = this.nowVariableNames;
          this.$api.reportApi.exportVariableHistoryWithDateType(
            JSON.stringify(info),
            this.nowSelectDate.getTime(),
            undefined,
            60,
            title,
            "year",
            (respon) => {
              saveAs(
                DWSystemSetting.downloadUrl + "/" + respon,
                title + ".xls"
              );
            }
          );
          break;
      }
    },
    reloadChart(list) {
      var selected = {};
      var legend = [];
      var seriesList = [];
      switch (this.nowTimetype) {
        case "day":
          for (var i = 0, len = list.length; i < len; i++) {
            var item = list[i][0];
            var name = this.from2name[item.variablename]
              ? this.from2name[item.variablename]
              : item.variablename;
            name = name.subByFirstChar(".");
            var dataList = item.data;
            var vlist = [];
            //取整点值
            for (var i2 = 0, len2 = dataList.length; i2 * 12 < len2; i2++) {
              var item2 = dataList[i2 * 12];
              if (isNaN(parseFloat(item2)) || isnull(parseFloat(item2))) {
                item2 = undefined;
              }
              var label = (i2 < 10 ? "0" : "") + i2 + ":00";
              vlist.push([label, item2]);
            }
            seriesList.push({
              name: name,
              fromName: item.variablename,
              type: "line",
              smooth: true,
              markPoint: {
                data: [
                  {
                    name: "最大值",
                    type: "max",
                  },
                ],
              },
              symbol: "emptyCircle",
              sampling: "average",
              data: vlist,
            });
            selected[name] = i < 6 ? true : false;
            legend.push({
              name: name,
              icon: "roundRect",
            });
          }
          this.options.title.text =
            this.nowVirtualDevice.name + " " + this.nowDateText + " 日报";
          break;
        case "week":
          var weekList = [
            "星期一",
            "星期二",
            "星期三",
            "星期四",
            "星期五",
            "星期六",
            "星期日",
          ];
          for (var i = 0, len = list.length; i < len; i++) {
            var item = list[i];
            var name = item.name;
            var vList = [];
            for (var i2 = 0, len2 = item.data.length; i2 < len2; i2++) {
              var item2 = item.data[i2];
              if (isNaN(parseFloat(item2)) || isnull(parseFloat(item2))) {
                item2 = undefined;
              }
              vList.push([weekList[i2], item2]);
            }
            seriesList.push({
              name: name,
              type: "line",
              smooth: true,
              markPoint: {
                data: [
                  {
                    name: "最大值",
                    type: "max",
                  },
                ],
              },
              symbol: "emptyCircle",
              sampling: "average",
              data: vList,
            });
            selected[name] = i < 6 ? true : false;
            legend.push({
              name: name,
              icon: "roundRect",
            });
          }
          this.options.title.text =
            this.nowVirtualDevice.name + " " + this.nowDateText + " 周报";
          break;
        case "month":
          for (var i = 0, len = list.length; i < len; i++) {
            var item = list[i][0];
            var name = this.from2name[item.variablename]
              ? this.from2name[item.variablename]
              : item.variablename;
            name = name.subByFirstChar(".");
            var dataList = item.data;
            var vlist = [];
            for (var i2 = 0, len2 = dataList.length; i2 < len2; i2++) {
              var item2 = dataList[i2];
              if (isNaN(parseFloat(item2)) || isnull(parseFloat(item2))) {
                item2 = undefined;
              }
              vlist.push([i2 + 1 + "日", item2]);
            }
            seriesList.push({
              name: name,
              fromName: item.variablename,
              type: "line",
              smooth: true,
              symbol: "emptyCircle",
              markPoint: {
                data: [
                  {
                    name: "最大值",
                    type: "max",
                  },
                ],
              },
              sampling: "average",
              data: vlist,
            });
            selected[name] = i < 6 ? true : false;
            legend.push({
              name: name,
              icon: "roundRect",
            });
          }
          this.options.title.text =
            this.nowVirtualDevice.name + " " + this.nowDateText + " 月报";
          break;
        case "quarter":
          var quarter = parseInt((this.nowSelectDate.getRealMonth() + 2) / 3);
          var Month = [
            ["一月", "二月", "三月"],
            ["四月", "五月", "六月"],
            ["七月", "八月", "九月"],
            ["十月", "十一月", "十二月"],
          ];
          var quarterList = Month[quarter - 1];
          for (var i = 0, len = list.length; i < len; i++) {
            var item = list[i];
            var name = item.name;
            var vList = [];
            for (var i2 = 0, len2 = item.data.length; i2 < len2; i2++) {
              var item2 = item.data[i2];
              if (isNaN(parseFloat(item2)) || isnull(parseFloat(item2))) {
                item2 = undefined;
              }
              vList.push([quarterList[i2], item2]);
            }
            seriesList.push({
              name: name,
              type: "line",
              smooth: true,
              symbol: "emptyCircle",
              markPoint: {
                data: [
                  {
                    name: "最大值",
                    type: "max",
                  },
                ],
              },
              sampling: "average",
              data: vList,
            });
            selected[name] = i < 6 ? true : false;
            legend.push({
              name: name,
              icon: "roundRect",
            });
          }
          var quarterText = parseInt(
            (this.nowSelectDate.getRealMonth() + 2) / 3
          );
          this.options.title.text =
            this.nowVirtualDevice.name +
            " " +
            "第 " +
            quarterText +
            " 季度 季报";
          break;
        case "year":
          for (var i = 0, len = list.length; i < len; i++) {
            var vList = list[i];
            var name = vList.shift(0);
            vList.remove(0);
            vList.remove(0);
            selected[name] = i < 6 ? true : false;
            legend.push({
              name: name,
              icon: "roundRect",
            });
            seriesList.push({
              name: name,
              type: "line",
              smooth: true,
              symbol: "emptyCircle",
              markPoint: {
                data: [
                  {
                    name: "最大值",
                    type: "max",
                  },
                ],
              },
              sampling: "average",
              data: vList.map((item, index) => {
                var temp = item;
                if (isNaN(parseFloat(temp)) || isnull(parseFloat(temp))) {
                  temp = undefined;
                }
                return [index + 1 + "月", temp];
              }),
            });
          }
          this.options.title.text =
            this.nowVirtualDevice.name + " " + this.nowDateText + " 年报";
          break;
      }
      this.options.series = seriesList;
      this.options.legend.data = legend;
      this.options.legend.selected = selected;
      this.$refs.vchart.setData(this.options, true);
    },
  },
};
</script>

<style scoped lang="scss">
.tabled {
  width: 98%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 8%;
  background-color: white;
}
.monreportRigth {
  width: 85%;
  height: 100%;
  overflow: hidden;
  /* padding-bottom: 20px; */
}

/deep/.el_Tree_Body {
  height: 95.5% !important;
}

.tableData {
  width: 100%;
}

.tableData tr:nth-child(1) td {
  text-align: center;
  border: 0.01rem solid;
  margin-top: 0.1rem;
}

.VirtualDeviceRTValue {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
}

.VirtualDeviceRTValueRigth {
  width: 100%;
  height: 100%;
  /*overflow: hidden;*/
  /* padding-bottom: 55px;
		margin-top: 70px; */
}

.virtualDeviceRTValueBody {
  width: 100%;
  display: flex !important;
  /* align-items: center; */
  justify-content: space-between;
}
</style>
